<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';

export default {
inject: ['setLoading'],  
  data() {
    return {
     errors: {}, 
     id: '',
     name: '',
     rate: '',
    };
  },
  methods: {
   add(){
    this.resetForm();
   },
   editTax(tax) {
    this.id = tax.id;
    this.name = tax.name;
    this.rate = tax.rate;
   },  

   async addUpdateTax(){
    this.errors = {};
    this.setLoading(true); 

    try{
     if(this.id){
      //UPDATE
      const response = await axios.put('/taxes/update', {
       id: this.id, 
       name: this.name,
       rate: this.rate
      });
      this.$swalToast(response.data.message);
     }else{
      //CREATE
      const response = await axios.post('/taxes/create', {
       name: this.name,
       rate: this.rate
      });
      this.$swalToast(response.data.message);
     }

     this.$emit('updated'); 
     this.closeModal('tax_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.$swalToast(error.message, 'error');
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteTax(){
   this.setLoading(true);
   try{
    const response = await axios.delete(`/taxes/${this.id}/delete`);
    this.$swalToast(response.data.message);
    this.$emit('updated');
    this.closeModal('delete_modal');
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
  }, 

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.name = '';
   this.rate = '';
   this.errors = {};
  },

  },
};
</script>

<template>
  <!-- Add -->
  <div class="modal fade" id="tax_modal">
    <div class="modal-dialog modal-dialog-centered modal-mg w-100">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} Tax</h4>
          <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
           <i class="ti ti-x"></i>
          </button>
        </div>
        <form @submit.prevent="addUpdateTax">
          <div class="modal-body pb-0">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Tax Name</label>
                  <input type="text" class="form-control" v-model="name" />
                  <div v-if="errors.name" class="text-danger small mt-1">{{ errors.name[0] }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Tax Rate</label>
                  <input type="text" class="form-control" v-model="rate" />
                  <div v-if="errors.rate" class="text-danger small mt-1">{{ errors.rate[0] }}</div>
                </div>
              </div>
              
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
            <button type="submit" class="btn btn-primary">{{ id ? 'Edit' : 'Add' }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add -->

  <!-- Delete Modal -->
  <div class="modal fade" id="delete_modal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
            <i class="ti ti-trash-x fs-36"></i>
          </span>
          <h4 class="mb-1">Confirm Delete</h4>
          <p class="mb-3">
            You want to delete the item, this cant be undone once you delete.
          </p>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
            <a href="javascript:void(0);" class="btn btn-danger" @click="deleteTax">Yes, Delete</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal -->
</template>
